import { AsyncActionStatus } from '../actions/common.actionTypes';
import type { StoreType } from '.';

export const selectStripeSchoolTeachers = (state: StoreType) =>
	state.stripeSchoolTeachers.teachers.data;

export const selectStripeSchoolTeachersLoading = (state: StoreType) =>
	state.stripeSchoolTeachers.teachers.status === AsyncActionStatus.LOADING;

export const selectStripeSchoolTeachersError = (state: StoreType) =>
	state.stripeSchoolTeachers.teachers.status === AsyncActionStatus.ERROR
		? state.stripeSchoolTeachers.teachers.error
		: undefined;

export const selectStripeSchoolSeats = (state: StoreType) => state.stripeSchoolTeachers.seats.data;

export const selectStripeSchoolSeatsLoading = (state: StoreType) =>
	state.stripeSchoolTeachers.seats.status === AsyncActionStatus.LOADING;

export const selectStripeSchoolSeatsError = (state: StoreType) =>
	state.stripeSchoolTeachers.seats.status === AsyncActionStatus.ERROR
		? state.stripeSchoolTeachers.seats.error
		: undefined;
